export default class smsText {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: require('../../../../views/campaign/partials/sms-text.html'),
            controller: [
                '$scope', '$element', '$attrs', '$rootScope', 'Campaign', 'StringUtils',
                (scope, element, attrs, rootScope, campaignRepo, stringUtils) => {

                    rootScope.$on('event:show-sms-text', ($event, campaign) => {
                        $('body').addClass('stop-scrolling');
                        scope.campaign = {};
                        scope.showPopup = true;
                        scope.campaign = campaign;
                        campaignRepo.getLatestTextMessageContent(scope.campaign.id).then((response) => {
                            scope.campaign.text = stringUtils.trimWithLeaveTrailNewline(response.content.replace('%TextMessage:Stop%', ''));
                        });
                    });

                    scope.closePopup = () => {
                        scope.showPopup = false;
                        $('body').removeClass('stop-scrolling');
                    };

                }]
        }
    }
}